export default __webpack_public_path__ + "static/media/PowerPoleWall_MK1.256.bd39327e.png";